import { Col, Menu, MenuProps, Row, theme } from 'antd';
import { Route, Routes, matchRoutes, useLocation, useResolvedPath } from 'react-router-dom';

export interface RouteDefinition {
  id: string;
  path: string;
  element: React.ReactNode;
}

interface VerticalTabsProps {
  routes: RouteDefinition[];
  menuItems: MenuProps['items'];
}

export const VerticalTabs: React.FC<VerticalTabsProps> = ({ routes, menuItems }) => {
  const displayMenu = !!(menuItems && menuItems.length > 1);
  const currentRoutePath = useResolvedPath('').pathname;

  const location = useLocation();
  const matchedPages = matchRoutes(
    routes.map((r) => {
      return {
        id: r.id,
        path: `${currentRoutePath}/${r.path}`
      };
    }),
    location
  );
  const matchedIds = matchedPages ? matchedPages.map((x: any) => x.route.id.toString()) : [];

  const {
    token: { colorTextBase }
  } = theme.useToken();
  return (
    <Row style={{ color: colorTextBase }}>
      {displayMenu && (
        <Col span={5}>
          <Menu mode="inline" defaultSelectedKeys={matchedIds} selectedKeys={matchedIds} style={{ borderColor: '#3f4373' }} items={menuItems} />
        </Col>
      )}
      <Col span={displayMenu ? 19 : 24} style={{ paddingLeft: '24px', paddingTop: '18px' }}>
        <Routes>
          {routes.map((route) => (
            <Route key={route.id} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Col>
    </Row>
  );
};
